import React from "react";

export const ConfirmationImage: React.FC = () => {
  return (
    <svg width="298" height="279" viewBox="0 0 298 279" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="141.157" cy="141.534" r="102.47" fill="#1B6CA1" fillOpacity="0.1" />
      <circle cx="141.157" cy="141.534" r="69.0103" fill="#1A6AA0" fillOpacity="0.1" />
      <circle cx="141.157" cy="141.534" r="46.0069" fill="url(#paint0_linear_842_5600)" />
      <path
        d="M126.519 138.397L118.154 147.808L135.93 161.4L164.161 131.078L154.751 122.713L135.93 147.808L126.519 138.397Z"
        fill="white"
      />
      <circle cx="132.694" cy="14.6177" r="3.37358" fill="#36A4DC" />
      <circle cx="292.377" cy="172.05" r="5.62263" fill="#FCC53D" />
      <circle cx="258.641" cy="136.067" r="3.37358" fill="#9994C1" />
      <circle cx="247.397" cy="210.286" r="3.37358" fill="#36A4DC" />
      <circle cx="96.7095" cy="266.512" r="3.37358" fill="#FCC53D" />
      <circle cx="11.2447" cy="158.557" r="3.37358" fill="#9994C1" />
      <circle cx="42.731" cy="37.1099" r="3.37358" fill="#FFE39E" />
      <rect x="3.37305" y="101.207" width="2.24905" height="8.9962" fill="#9994C1" />
      <rect y="106.832" width="2.24905" height="8.9962" transform="rotate(-90 0 106.832)" fill="#9994C1" />
      <rect x="231.654" y="258.639" width="2.24905" height="8.9962" fill="#FCC53D" />
      <rect x="222.656" y="22.4902" width="2.24905" height="8.9962" fill="#0BB31C" />
      <rect x="47.2305" y="258.639" width="2.24905" height="8.9962" fill="#0BB31C" />
      <rect x="185.545" y="269.887" width="2.24905" height="8.9962" fill="#0BB31C" />
      <rect
        x="228.281"
        y="264.264"
        width="2.24905"
        height="8.9962"
        transform="rotate(-90 228.281 264.264)"
        fill="#FCC53D"
      />
      <rect
        x="219.283"
        y="28.1152"
        width="2.24905"
        height="8.9962"
        transform="rotate(-90 219.283 28.1152)"
        fill="#0BB31C"
      />
      <rect
        x="43.8574"
        y="264.264"
        width="2.24905"
        height="8.9962"
        transform="rotate(-90 43.8574 264.264)"
        fill="#0BB31C"
      />
      <path
        d="M80.9644 0L82.2268 4.66217L86.3119 4.66217L83.007 7.54354L84.2693 12.2057L80.9644 9.32433L77.6595 12.2057L78.9219 7.54354L75.617 4.66217L79.7021 4.66217L80.9644 0Z"
        fill="#9994C1"
      />
      <path
        d="M33.7359 197.914L34.9983 202.576L39.0833 202.576L35.7784 205.458L37.0408 210.12L33.7359 207.238L30.431 210.12L31.6934 205.458L28.3885 202.576L32.4735 202.576L33.7359 197.914Z"
        fill="#36A4DC"
      />
      <path
        d="M269.884 67.4707L271.147 71.3558H275.232L271.927 73.757L273.189 77.6421L269.884 75.241L266.579 77.6421L267.842 73.757L264.537 71.3558H268.622L269.884 67.4707Z"
        fill="#FCC53D"
      />
      <defs>
        <linearGradient
          id="paint0_linear_842_5600"
          x1="141.157"
          y1="95.5273"
          x2="141.157"
          y2="187.541"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1D70A5" />
          <stop offset="1" stopColor="#073F78" />
        </linearGradient>
      </defs>
    </svg>
  );
};
